import type { ConventionPaymentVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveConventionTransferList = createApiThunk<ConventionPaymentVM[], void>(
  "transfers/retrieveConventionTransferList",
  async (_: void, { extra: { adminRepository } }) => {
    return adminRepository!.listConventionTransfers();
  },
);
